import SwitchOrganizationButton from '@v2/domains/organization/components/SwitchOrganizationButton/SwitchOrganizationButton.component'
import { selectOrganizations } from '@v2/domains/user/selectors/user.selectors'
import { useState } from 'react'

import { Portal, SearchField } from 'src/common/components'
//TODO-MIGRATION
import { useDocumentTitle } from 'src/common/hooks'
//TODO-MIGRATION
import { useAppSelector } from 'src/v2/store/hooks'

import withErrorBoundaryAndPolicyCheck from '../../../v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import Sidebar from './Sidebar'
import Topbar from './Topbar'
import styles from './basic-template-wrapper.module.scss'

const BasicTemplateWrapper = (props: React.PropsWithChildren<{}>) => {
  const { children } = props
  useDocumentTitle('')

  const organizationsByUser = useAppSelector(selectOrganizations)

  const [showMobileSidebar, setShowMobileSidebar] = useState<boolean>(false)

  return (
    <>
      <div className={styles.wrapper}>
        <Sidebar
          showMobile={showMobileSidebar}
          onClose={() => setShowMobileSidebar(false)}
        />

        <div className={styles.inner}>
          <Topbar
            onBurgerToggle={() => setShowMobileSidebar(!showMobileSidebar)}
          >
            {organizationsByUser.length > 1 ? (
              <SwitchOrganizationButton />
            ) : null}

            <Portal.Target
              className={styles.desktopSearch}
              id="searchField"
              media="desktop"
            />
          </Topbar>
          {children}
        </div>
      </div>

      <SearchField />
    </>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  BasicTemplateWrapper,
  'is_enable_basic_template_wrapper',
  true,
)
